// src/api/warrantyApi.js
import apiClient from './axios';

const warrantyApi = {
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/tealtik/items', {
      params: { page, page_size: pageSize, search },
    });
    return response.data;
  },

  create: async (formData) => {
    const response = await apiClient.post('/tealtik/items', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  update: async (id, formData) => {
    formData.append('_method', 'PUT');
    const response = await apiClient.post(`/tealtik/items/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/tealtik/items/${id}`);
    return id;
  },


  exportCsv: async () => {
    const response = await apiClient.get('/tealtik/items/export', {
      responseType: 'blob',
    });
    return response.data;
  },

  importPreview: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/tealtik/items/import-preview', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post('/tealtik/items/import-confirm', { preview });
    return response.data;
  },
};

export default warrantyApi;